<template>
  <div>
    <el-menu
      :default-active="activeIndex"
      :class="mode == 'horizontal' ? 'nav-bar-box' : ''"
      :mode="mode"
      active-text-color="#1390FF"
      :text-color="mode == 'horizontal' ? '#fff' : '#000'"
      @select="handleSelect"
    >
      <template v-for="(item, index) in pageUrl">
        <template v-if="item.children && mode == 'horizontal'">
          <el-submenu
            :key="item.title"
            :ref="index + 'submenu'"
            :index="index + ''"
            @click.native="handleSelectMenu(index, item)"
          >
            <template slot="title">
              {{ item.title }}
            </template>
            <el-menu-item
              v-for="(child, i) in item.children"
              :key="child.title"
              :index="index + '-' + i"
            >
              {{ child.title }}
            </el-menu-item>
          </el-submenu>
        </template>
        <el-menu-item
          v-else
          :key="item.title"
          :index="index + ''"
        >
          {{ item.title }}
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  props: {
    mode: {
      type: String,
      default: "horizontal",
    },
  },
  data() {
    return {
      activeIndex: sessionStorage.getItem("activeName") || "0",
      pageUrl: Object.freeze([
        {
          title: "首页",
          url: "/",
          name: "Home",
        },
        {
          title: "解决方案",
          url: "/solution",
          name: "Solution",
        },
        {
          title: "核心技术",
          url: "/core",
          name: "Core",
        },
        {
          title: "标准产品",
          url: "/product",
          name: "Product",
        },
        {
          title: "关于我们",
          url: "/aboutUs",
          name: "AboutUs",
          // children: [
          //   {
          //     title: "公司介绍",
          //     url: "/aboutUs",
          //     name: "companyProfile",
          //   },
          //   {
          //     title: "公司动态",
          //     url: "/aboutUs",
          //     name: "companyDynamics",
          //   },
          //   {
          //     title: "荣誉资质",
          //     url: "/aboutUs",
          //     name: "honorsAndQualifications",
          //   },
          // ],
        },
      ]),
    };
  },
  watch:{
    '$route':{
      handler(val){
        this.activeIndex = '';
        if(val.name == "AboutUs"){
          this.activeIndex = '4';
        }if(val.name === 'Solution'){
          this.activeIndex = '1';
        }if(val.name === 'Core'){
          this.activeIndex = '2';
        }if(val.name === 'Home'){
          this.activeIndex = '0';
        }if(val.name === 'Product'){
          this.activeIndex = '3';
        }

      },
      immediate:true
    }
  },
  methods: {
    handleSelect(index, typeName) {
      if (this.mode == "vertical") {
        this.$emit("emitClick");
      }
			this.$set(this, "activeIndex", index);
      const arr = index.split("-");
      let name = "", param = "";
      if (arr[1]) {
        const i0 = arr[0];
        const i1 = arr[1];
        name = this.pageUrl[i0].name;
        // param = this.pageUrl[i0].children[i1].name;
      } else {
        name = this.pageUrl[index].name;
				param = 'define'
      }
      if (name == "Solution" && typeof typeName !== "string") {
        typeName = "jinrong";
      }
      if (name == "AboutUs") {
        typeName = 'define'
      }
      this.$router
        .push({
          name,
          params: {
            id: typeName,
            type: typeName,
          },
        })
        .then(() => {
          sessionStorage.setItem("activeName", index);
        });
			
    },
    handleSelectMenu(index, item) {
      this.activeIndex = index + "-0";
      this.$router.push({
        name: item.name,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-bar-box {
  margin-left: 100px;
}
.el-menu.el-menu--horizontal {
  border: none;
  >.el-menu-item:not(.is-disabled):focus{
    background: transparent;
  }
}
::v-deep .el-menu {
  background: transparent;
  .el-menu-item {
    padding: 0px;
    background: transparent;
    font-size: 16px;
  }
  .is-active {
    background: transparent !important;
  }
  .el-submenu__title {
    font-size: 16px;
    height: 40px;
    line-height: 40px;
  }
  .el-submenu__title {
    padding: 0px;
    margin: 0 20px;
  }
}

::v-deep.el-menu--horizontal > .el-menu-item {
  height: 40px;
  line-height: 40px;
  margin: 0 20px;
}

::v-deep.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover,
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: transparent;
  color: #1390ff;
}
::v-deep .el-menu {
  background: transparent;
  .el-menu-item {
    color: #ffffff;
    font-size: 16px;
    background: transparent;
  }
  .el-submenu__title {
    font-size: 16px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
}

::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title:hover {
  background: transparent;
  color: #1390ff;
}
</style>
